import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import TableStateManager from './util/TableStateManager';
import { DataTable } from '../DataTable';

const Table = ({ columns, data, initialState, rowClickAction, label, id, withActions, withHeader, ...rest }) => {
    // This effectively just serves to memoize the data from our data controller
    const dataMemo = useMemo(() => data, [data]);
    const columnsMemo = useMemo(() => columns, [columns]);

    return (
        <TableStateManager defaultTableState={initialState}>
            {({ setTableState, tableState }) => (
                <DataTable
                    style={{ justifyContent: 'center' }}
                    columns={columnsMemo}
                    data={dataMemo}
                    setTableState={setTableState}
                    rowClickAction={rowClickAction}
                    tableState={tableState}
                    id={`datatable--${id}`}
                    label={label}
                    showHeader={withHeader}
                    {...rest}
                />
            )}
        </TableStateManager>
    );
};

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    initialState: PropTypes.object,
    tableProps: PropTypes.object,
    sortableRows: PropTypes.bool,
    withActions: PropTypes.bool,
    withHeader: PropTypes.bool,
    label: PropTypes.string,
    id: PropTypes.string,
    rowClickAction: PropTypes.func,
    dndContextProps: PropTypes.shape({
        onDragEnd: PropTypes.func,
        onDragStart: PropTypes.func,
        onDragCancel: PropTypes.func,
        getDraggableId: PropTypes.func,
        activeId: PropTypes.string
    })
};

Table.defaultProps = {
    initialState: {}
};

export default Table;
